
export const ORDER_NOW_LINK = "https://300fsmokehouseoow.petpooja.com/";